module.exports = __webpack_public_path__ + "img/bg.5aa3b196.png";